(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sky-demo"]) return;
  try {
    
  document.querySelectorAll('[data-youtube-facade]').forEach(function (facade) {
    var button = facade.querySelector('[data-youtube-play]');
    if (!button) return;
    button.addEventListener('click', function () {
      var iframe = document.createElement('iframe');
      iframe.src = 'https://www.youtube-nocookie.com/embed/' +
        facade.getAttribute('data-youtube-id') + '?autoplay=1&rel=0';
      iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
      iframe.allowFullscreen = true;
      iframe.title = 'Sky Bridge review';
      facade.innerHTML = '';
      facade.appendChild(iframe);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["storm-demo"]) return;
  try {
    
  document.querySelectorAll('[data-youtube-facade]').forEach(function (facade) {
    var button = facade.querySelector('[data-youtube-play]');
    if (!button) return;
    button.addEventListener('click', function () {
      var iframe = document.createElement('iframe');
      iframe.src = 'https://www.youtube-nocookie.com/embed/' +
        facade.getAttribute('data-youtube-id') + '?autoplay=1&rel=0';
      iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
      iframe.allowFullscreen = true;
      iframe.title = 'Storm Summoner review';
      facade.innerHTML = '';
      facade.appendChild(iframe);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tutorial-gallery"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-tutorial-gallery]');
    if (!root) return;

    var manifest;
    try {
      manifest = JSON.parse(root.querySelector('[data-tutorial-manifest]').textContent);
    } catch (err) {
      console.error('Tutorial manifest is not valid JSON', err);
      return;
    }

    var videos = manifest.videos || [];
    if (!videos.length) return;

    var grid = root.querySelector('[data-tutorial-tiles]');
    var dialog = root.querySelector('[data-tutorial-dialog]');
    var stage = root.querySelector('[data-tutorial-stage]');
    var titleEl = root.querySelector('[data-tutorial-title]');
    var upnextEl = root.querySelector('[data-tutorial-upnext]');
    var prevBtn = root.querySelector('[data-tutorial-prev]');
    var nextBtn = root.querySelector('[data-tutorial-next]');
    var closeBtn = root.querySelector('[data-tutorial-close]');

    var current = -1;
    var playerjsPromise = null;

    function isPlaceholder(video) {
      return !video.guid || video.guid.indexOf('PLACEHOLDER') === 0 ||
        String(manifest.libraryId).indexOf('PLACEHOLDER') === 0;
    }

    function formatDuration(seconds) {
      if (!seconds) return '';
      var m = Math.floor(seconds / 60);
      var s = seconds % 60;
      return m + ':' + String(s).padStart(2, '0');
    }

    function thumbnailUrl(video) {
      return 'https://' + manifest.pullZone + '.b-cdn.net/' + video.guid + '/thumbnail.jpg';
    }

    function embedUrl(video) {
      return 'https://iframe.mediadelivery.net/embed/' + manifest.libraryId + '/' +
        video.guid + '?autoplay=true&preload=true';
    }

    function loadPlayerjs() {
      if (playerjsPromise) return playerjsPromise;
      playerjsPromise = new Promise(function (resolve, reject) {
        if (window.playerjs) return resolve(window.playerjs);
        var script = document.createElement('script');
        script.src = 'https://assets.mediadelivery.net/playerjs/player-0.1.0.min.js';
        script.onload = function () { resolve(window.playerjs); };
        script.onerror = reject;
        document.head.appendChild(script);
      });
      return playerjsPromise;
    }

    // Build tiles.
    videos.forEach(function (video, index) {
      var tile = document.createElement('button');
      tile.type = 'button';
      tile.className = 'tutorials__tile';
      tile.setAttribute('data-index', index);

      if (isPlaceholder(video)) {
        var ph = document.createElement('div');
        ph.className = 'tutorials__thumb tutorials__thumb--placeholder';
        tile.appendChild(ph);
      } else {
        var img = document.createElement('img');
        img.className = 'tutorials__thumb';
        img.src = thumbnailUrl(video);
        img.alt = '';
        img.loading = 'lazy';
        img.width = 1280;
        img.height = 720;
        tile.appendChild(img);
      }

      var meta = document.createElement('div');
      meta.className = 'tutorials__tile-meta';

      var topic = document.createElement('span');
      topic.className = 'tutorials__tile-topic';
      topic.textContent = video.topic || '';
      meta.appendChild(topic);

      var title = document.createElement('span');
      title.className = 'tutorials__tile-title';
      title.textContent = video.title;
      meta.appendChild(title);

      var duration = document.createElement('span');
      duration.className = 'tutorials__tile-duration';
      duration.textContent = formatDuration(video.duration);
      meta.appendChild(duration);

      tile.appendChild(meta);
      tile.addEventListener('click', function () { open(index); });
      grid.appendChild(tile);
    });

    function updateChrome() {
      var video = videos[current];
      var next = videos[current + 1];
      titleEl.textContent = video.title;
      upnextEl.textContent = next ? 'Up next: ' + next.title : 'Last one — nice work.';
      prevBtn.disabled = current <= 0;
      nextBtn.disabled = current >= videos.length - 1;
    }

    function loadVideo(index) {
      current = index;
      var video = videos[index];
      stage.innerHTML = '';

      if (isPlaceholder(video)) {
        var note = document.createElement('p');
        note.className = 'tutorials__stage-placeholder';
        note.textContent = 'This tutorial hasn\u2019t been filmed yet. The player wiring is ready and waiting for it.';
        stage.appendChild(note);
        updateChrome();
        return;
      }

      var iframe = document.createElement('iframe');
      iframe.src = embedUrl(video);
      iframe.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; fullscreen';
      iframe.allowFullscreen = true;
      stage.appendChild(iframe);
      updateChrome();

      if (history.replaceState) {
        history.replaceState(null, '', '#tutorial=' + video.guid);
      }

      loadPlayerjs().then(function (playerjs) {
        var player = new playerjs.Player(iframe);
        player.on('ready', function () {
          player.on('ended', function () {
            if (current < videos.length - 1) loadVideo(current + 1);
          });
        });
      }).catch(function () {
        // Playback still works without player.js; only auto-advance is lost.
      });
    }

    function open(index) {
      if (!dialog.open) dialog.showModal();
      loadVideo(index);
    }

    function close() {
      dialog.close();
    }

    dialog.addEventListener('close', function () {
      stage.innerHTML = '';
      current = -1;
      if (history.replaceState) {
        history.replaceState(null, '', location.pathname + location.search);
      }
    });

    // Click on the backdrop closes; clicks inside the body don't.
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) close();
    });

    prevBtn.addEventListener('click', function () {
      if (current > 0) loadVideo(current - 1);
    });
    nextBtn.addEventListener('click', function () {
      if (current < videos.length - 1) loadVideo(current + 1);
    });
    closeBtn.addEventListener('click', close);

    // Deep link: #tutorial=GUID opens straight into that video.
    var match = location.hash.match(/^#tutorial=(.+)$/);
    if (match) {
      var target = videos.findIndex(function (v) { return v.guid === match[1]; });
      if (target >= 0) open(target);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
